import { CashRequestMiddleware } from './types'
export const ensureHeadersRequest: CashRequestMiddleware = request => {
  if (request.headers == null) {
    request.headers = { 'Content-Type': 'application/json; charset=utf-8', Accept: 'application/json' }
  }
  return request
}
